import React from 'react';
import { motion } from 'framer-motion';
import { Linkedin, Mail, Globe } from 'lucide-react';
import logo from '../assets/logo.png';

export const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-zinc-950 text-white py-16 border-t border-zinc-900">
      <div className="container mx-auto px-6">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <img src={logo} alt="UGW GLOBAL" className="h-12 w-auto mb-6" />
            <p className="text-zinc-400 max-w-md leading-relaxed mb-6">
              Advisory • Brokerage • Capital Solutions. <br/>
              Specialists in Natural Resources, Commodities, Hospitality & Real Estate.
            </p>
            <div className="flex gap-4">
              <a href="#" className="w-10 h-10 bg-zinc-900 flex items-center justify-center rounded-sm hover:bg-amber-500 hover:text-zinc-900 transition-all duration-300">
                <Linkedin className="w-5 h-5" />
              </a>
              <a href="mailto:info@ugw-global.com" className="w-10 h-10 bg-zinc-900 flex items-center justify-center rounded-sm hover:bg-amber-500 hover:text-zinc-900 transition-all duration-300">
                <Mail className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Links */}
          <div>
            <h4 className="font-bold uppercase tracking-widest text-sm mb-6 text-zinc-500">Company</h4>
            <ul className="space-y-3 text-zinc-400">
              <li><a href="#about" className="hover:text-amber-500 transition-colors">About Us</a></li>
              <li><a href="#services" className="hover:text-amber-500 transition-colors">Services</a></li>
              <li><a href="#sectors" className="hover:text-amber-500 transition-colors">Sectors</a></li>
              <li><a href="#network" className="hover:text-amber-500 transition-colors">Global Network</a></li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="font-bold uppercase tracking-widest text-sm mb-6 text-zinc-500">Legal</h4>
            <ul className="space-y-3 text-zinc-400">
              <li><a href="#" className="hover:text-amber-500 transition-colors">Privacy Policy</a></li>
              <li><a href="#" className="hover:text-amber-500 transition-colors">Terms of Service</a></li>
              <li><a href="#" className="hover:text-amber-500 transition-colors">Disclaimer</a></li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-zinc-900 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-zinc-500">
          <div>
            © {currentYear} UGW GLOBAL. All rights reserved.
          </div>
          <div className="flex items-center gap-2">
            <Globe className="w-4 h-4" />
            <span>Operating Worldwide</span>
          </div>
        </div>
      </div>
    </footer>
  );
};